import apiAuthCall from 'helpers/apiAuthCall';
import { MixpanelAnalytics } from 'tracking/mixpanelBeconTarget';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { logUserFeedbackEndpoint, promptUserFeedbackEndpoint } from 'services/feedback/selectors';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import {
    logUserFeedback,
    logUserFeedbackSuccess,
    actions,
    promptUserFeedback,
    setHasCheckedForFeedbackPrompt
} from 'services/feedback/duck';
import { destroy } from 'redux-form';
import { FEEDBACK_PROMPT } from 'constants/capabilities';
import { get } from 'lodash';

const getFeedbackMetaData = (state) => {
    const feedbackData = {
        feedbackType: state.feedback.feedbackPromptId ? 'prompted' : 'user-initiated',
        meta: {
            url: state.router.parsedUrl.href
        }
    };

    if (state.feedback.feedbackPromptId) {
        feedbackData.feedbackPromptId = state.feedback.feedbackPromptId;
    } else {
        delete feedbackData.feedbackPromptId;
    }

    return feedbackData;
};

export function* sendUserFeedback(api, action) {
    const notificationId = 'logUserFeedback';
    const state = action.getState();

    try {
        const result = yield apiAuthCall(
            state,
            [api, api.request],
            {
                method: 'post',
                url: yield select(logUserFeedbackEndpoint),
                data: { ...action.payload, ...getFeedbackMetaData(state) }
            }
        );

        MixpanelAnalytics([{
            hitType: 'event',
            eventAction: 'Feedback Submitted',
            ...action.payload,
            ...getFeedbackMetaData(state)
        }]);

        yield put(notify({
            id: notificationId,
            message: 'Thank you for your feedback!',
            status: result.status
        }));

        yield put(logUserFeedbackSuccess());
        yield put(destroy('userFeedbackForm'));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

const canPromptUser = (props) => {
    const hasChecked = get(props, 'feedback.hasCheckedForFeedbackPrompt', false);
    const hasRight = get(props, 'users.currentUser.scope', []).includes(FEEDBACK_PROMPT);

    return !hasChecked && hasRight;
};

export const getShouldPromptUser = (api, state, url) => apiAuthCall(
    state,
    [api, api.request],
    {
        method: 'get',
        url,
    }
);

export function* shouldPromptUserFeedback(api, action) {
    const state = action.getState();

    if (canPromptUser(state)) {
        yield put(setHasCheckedForFeedbackPrompt());
        const url = yield select(promptUserFeedbackEndpoint);
        const result = yield getShouldPromptUser(api, state, url);

        if (result && result.data && result.data.promptFeedback) {
            const fiveSecs = 5000;
            const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
            yield sleep(fiveSecs);
            yield put(promptUserFeedback(result.data));
        }
    }
}

export default function* feedbackSaga({ api }) {
    yield all([
        takeLatest(logUserFeedback.REQUEST, sendUserFeedback, api),
        takeLatest(actions.SHOULD_PROMPT_USER_FEEDBACK, shouldPromptUserFeedback, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/feedback/saga.js